import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IUserActionResult } from '../../../../userManagement/users/serverApi/types/IUserActionResult';

export interface CreateLocalIdentityForUserParams {
  id: string;                // user id or system user id
  identityPoolName: string;  // name of the identity pool that will be used as a login mechanism for this user
  identifier: string;        // identifier for identity creation
}

export class CreateLocalIdentityForSiteUserRequest extends Request<CreateLocalIdentityForUserParams, IUserActionResult> {
  constructor(params: CreateLocalIdentityForUserParams) {
    super('createLocalIdentityForUser', params);
  }
}

export class CreateLocalIdentityForServerUserRequest extends Request<CreateLocalIdentityForUserParams, IUserActionResult> {
  constructor(params: CreateLocalIdentityForUserParams) {
    super('createLocalIdentityForServerUser', params);
  }
}
